var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "login-div" } },
    [
      _c("h1", { staticClass: "page-title mt-2" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("register.End")) + "\n  ")
      ]),
      _vm._v(" "),
      _c("h2", {
        staticClass: "content mt-4",
        domProps: {
          innerHTML: _vm._s(_vm.$t("register.sendCode", { mail: _vm.username }))
        }
      }),
      _vm._v(" "),
      _c(
        "b-alert",
        {
          staticClass: "mt-5",
          attrs: { show: _vm.ui.showError, variant: "danger" }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.$t("ValidateAccount.error")) + "\n    "),
          _c("br")
        ]
      ),
      _vm._v(" "),
      _c(
        "b-alert",
        {
          staticClass: "mt-5",
          attrs: { show: _vm.ui.showSuccess, variant: "success" }
        },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.$t("ValidateAccount.success")) + "\n    "
          ),
          _c("br")
        ]
      ),
      _vm._v(" "),
      _c(
        "b-alert",
        {
          staticClass: "mt-5",
          attrs: { show: _vm.showResendMessage, variant: "success" }
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("email.resent")) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "b-alert",
        {
          staticClass: "mt-5",
          attrs: {
            show: _vm.codeAttempts >= _vm.maxCodeAttempts,
            variant: "danger"
          }
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("Code.maxAttempts")) + "\n  ")]
      ),
      _vm._v(" "),
      _vm.needCode
        ? _c(
            "div",
            { staticClass: "code-input-container mt-4" },
            _vm._l(4, function(index) {
              return _c("b-input", {
                key: index,
                ref: "input" + index,
                refInFor: true,
                staticClass: "code-input",
                class: {
                  "input-success": _vm.ui.showSuccess,
                  "input-error": _vm.ui.showError
                },
                attrs: { maxlength: "1", type: "text" },
                on: {
                  keyup: function($event) {
                    return _vm.handleKeyup(index, $event)
                  },
                  keydown: function($event) {
                    return _vm.filterKey($event)
                  }
                },
                model: {
                  value: _vm.code[index - 1],
                  callback: function($$v) {
                    _vm.$set(_vm.code, index - 1, $$v)
                  },
                  expression: "code[index - 1]"
                }
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "d-flex mt-5 flex-column flex-lg-row justify-content-center align-items-center"
        },
        [
          _c("div", { staticClass: "content" }, [
            _vm._v(_vm._s(_vm.$t("email.needResend")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "link-main-color ml-lg-2 cursor-pointer",
              on: { click: _vm.resendValidateAccountMailCode }
            },
            [_vm._v(_vm._s(_vm.$t("email.sendAgain")))]
          ),
          _vm._v(" "),
          _vm.resendTimer > 0
            ? _c("div", { staticClass: "content ml-lg-2" }, [
                _vm._v(_vm._s("(" + _vm.resendTimer + "s)"))
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-4 d-flex justify-content-center" },
        [
          _c(
            "b-button",
            {
              staticClass: "px-5",
              attrs: { variant: "danger" },
              on: { click: _vm.logout }
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("Logout")) + "\n    ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ccbbcb2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ccbbcb2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/components/ValidateAccountComponent.vue
// module id = /0oX
// module chunks = 0